/* index.js */

// Scripts
import './js/scripts.js';

// Styles
import './sass/style.scss';
